<kendo-gridlayout
    [cols]="['','']"
    [gap]="{ rows: 8, cols: 8 }"
    >

    <kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
        <div class="example-box" style="display:flex; justify-content: space-between; flex-wrap: wrap;">
            <div>
            <!-- Read:                            
            <a href="https://learn.flowstudio.app/full-text-search" target="learn">FlowStudio for Teams</a>&nbsp; -->
            </div>
            <div>
            <span class="text-sm text-slate-500">Teams is a <span class="team-box"></span> subscription feature</span>
            </div>
        </div>
    </kendo-gridlayout-item>

     <kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
        <div style="padding:8px;"><b>Flows (Request Trigger Report)</b></div>
        <app-teams-flows [Type]="'request'"></app-teams-flows>
        <!-- <div style="text-decoration: underline; cursor:pointer;" (click)="downloadCsv()">
            Download Links for details
        </div> -->
    </kendo-gridlayout-item>

</kendo-gridlayout>